import React, { useContext, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import MinimalSelect from "./MinimalSelect";
import { SemesterContext } from "../context/SemesterContext";
import { hasNoCurriculumVersionsForExplore } from "../utils/exploreCompetency";
import { UserContext } from "../context/UserContext";

interface Props {
  onChange: any;
}

const VersionSelect = (props: Props) => {
  const { onChange } = props;
  const screenClass = useScreenClass();
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const allVersions = localStorage.getItem("allVersions");
  const activeVersion = localStorage.getItem("activeVersion");
  const { semesterVersions, selectedSemesterVersion, selectedSemester, semesterVersionsLoading } =
    useContext(SemesterContext);
  const { user } = useContext(UserContext);

  const semesterVersionOption = Array.isArray(semesterVersions)
    ? semesterVersions.find(
        (v: any) => v.curriculum_version === selectedSemesterVersion
      )
    : undefined;

  const selectedVersionObject = semesterVersionOption
    ? {
        label:
          semesterVersionOption.display_version +
          ". " +
          semesterVersionOption.title,
        value: semesterVersionOption.curriculum_version,
      }
    : JSON.parse(allVersions as string)?.find(
        (v: any) => v.value === selectedSemesterVersion
      ) || {};

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  const hasSemesterVersionOptions =
    Array.isArray(semesterVersions) && semesterVersions.length > 0;

  if (
    semesterVersionsLoading ||
    hasNoCurriculumVersionsForExplore(
      user.role,
      selectedSemester,
      semesterVersions,
      semesterVersionsLoading
    )
  ) {
    return null;
  }

  const selectWidth = isMobile ? "100%" : 350;
  const selectStyles = {
    container: (base: any) => ({
      ...base,
      width: selectWidth,
      minWidth: selectWidth,
    }),
    control: (base: any) => ({
      ...base,
      width: selectWidth,
      minWidth: selectWidth,
    }),
    menu: (base: any) => ({ ...base, width: selectWidth }),
    menuPortal: (base: any) => ({ ...base, zIndex: 99999 }),
  };

  return (
    <MinimalSelect
      styles={selectStyles}
      isDisabled={isDisabled}
      setClass={isMobile ? "rs-container" : ""}
      placeholder="Select Version"
      options={
        hasSemesterVersionOptions
          ? semesterVersions.map((v: any) => ({
              label: v?.display_version +
                ". " +
                v?.title,
              value: v?.curriculum_version,
            }))
          : JSON.parse(allVersions as string)
      }
      value={
        selectedSemesterVersion === 0 && !semesterVersionOption
          ? JSON.parse(activeVersion as string)
          : selectedVersionObject
      }
      onChange={(data: any) => {
        onChange(data);
      }}
    />
  );
};

export default VersionSelect;
